<template>
  <div class="viewDialog">
    <BaseDialog title="对账" :isshow="visible" @handleShow="(val) => {visible = val }" width="85%" height="auto">
      <div class="patentList fatherHeight contBox">
        <div>
          <div class="patentList fatherHeight contBox">
            <el-form :inline="true" :model="formData" ref="formDataRef" :rules="JsRule" class="demo-form-inline"
              :label-width="120" label-suffix=":">
              <el-form-item label="统计时间" prop="dict_pay_cate">
                <el-date-picker format="YYYY-MM-DD" value-format="YYYY-MM-DD" v-model="formData.time" type="daterange"
                  range-separator="-" placeholder="请选择" clearable @change="getDataList()"></el-date-picker>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <el-table v-loading="dataListLoading" :data="tableData" class="table-ellipsis" size="small"
          max-height="300" border>
          <el-table-column prop="insutype_name" align="center" label="险种类型" />
          <el-table-column prop="medfee_sumamt" align="center" label="医疗费总额" />
          <el-table-column prop="fund_pay_sumamt" align="center" label="基金支付总额" />
          <el-table-column prop="acct_pay" label="个人账户支出" align="center" />
          <el-table-column prop="fixmedins_setl_cnt" label="结算笔数" align="center" />
          <el-table-column fixed="right" label="操作" width="80" align="center">
            <template #default="scope">
              <el-link type="primary" @click="rejectInfo(scope.row)">
                对账
              </el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <template #footer>
        <div class="dialog-footer">
          <el-button class="color-cancel" type="primary" @click="visible = false">
            取消
          </el-button>
          <el-button @click="savePatient" :disabled="saveType==1?true:false" :loading="saveLoad" class="color-determine"
            type="primary">
            确定
          </el-button>
        </div>
      </template> -->
    </BaseDialog>
  </div>
</template>
<script setup name="reconciliatlation">
  import {
    reactive,
    toRefs,
    ref,
    nextTick,
    onMounted,
    onBeforeUnmount, defineEmits
  } from 'vue'
  import service from '@/utils/request'
  import { TimestampToTime } from '@/utils/tool'
  import { ElMessageBox, ElMessage } from 'element-plus'
  import BaseDialog from '@/components/Dialog/index.vue'
  const visible = ref(false)
  const saveLoad = ref(false)
  const emit = defineEmits(["jsConfirm"])
  const info = ref({})
  async function rejectInfo(row) {
    console.log(row)
    // let data = {
    //   ...row,
    //   start_time: formData.value.time[0],
    //   end_time: formData.value.time[1]
    // }
    let res = await service.post(
      '/api/settle/uploadStmt',
      row
    )
    if (res.code === 0) {
      ElMessage.success(res.msg)
    }
  }

  const formData = ref({})
  const dataListLoading = ref(false)
  const tableData = ref([])

  onMounted(() => {
    formData.value.time = [TimestampToTime(), TimestampToTime()]
  })

  const getDataList = async () => {
    let data = {
      start_time: formData.value.time[0],
      end_time: formData.value.time[1]
    }
    dataListLoading.value = true
    let res = await service.post(
      '/api/settle/getStmtInfo', data
    )
    dataListLoading.value = false
    if (res.code === 0) {
      tableData.value = res.data
    }
  }
  defineExpose({
    visible,
    info,
    getDataList,
  })
</script>
<style lang="scss">
  .el-notification__group {
    flex: 1;
  }

  .notice_but {
    text-align: right;
    color: #3167a8;
    cursor: pointer;
  }
</style>
<style scoped lang="scss">
  .table-tag {
    margin-right: 8px;
  }

  .fa-stack {
    width: 24px;
    height: 24px;
    cursor: pointer;
    float: right;

    .fa-stack-2x {
      font-size: 24px;
      color: rgba(49, 102, 174, 0.1);
    }

    .fa-stack-1x {
      font-size: 12px;
      color: #3166ae;
      line-height: 24px;
    }
  }

  .tagBox {
    display: flex;
    justify-content: flex-start;

    // margin-bottom: 10px;
    .tit {
      width: 83px;
      font-size: 14px;
      font-family: 'Source Han Sans CN-Bold';
      font-weight: bold;
      color: #666666;
    }

    .cont {
      width: calc(100% - 83px);
    }
  }

  .patientList {
    margin-top: 4px;
    height: calc(100% - 45px);
  }

  .list-top {
    .name {
      font-size: 18px;
      font-family: ' Source Han Sans CN-Medium';
      font-weight: 500;
      color: #000000;
      line-height: 32px;
    }
  }

  .patient-alert {
    background: rgba(49, 102, 174, 0.1);
    border-radius: 4px 4px 4px 4px;
    font-size: 18px;
    color: #3166ae;
    margin-top: 8px;
    padding: 4px 16px;

    .el-alert__icon {
      color: #3166ae;
    }

    &:deep(.el-alert__content) {
      position: relative;
      top: 3px;
    }
  }

  .table {
    margin-top: 10px;
    height: calc(100% - 82px);

    .img {
      width: 25px;
      height: 24px;
      margin-right: 14px;
    }
  }

  .searchBut {
    width: 100%;
    //margin-left: 20px;
    //margin-right: 29px;
    justify-self: right;
    display: flex;
    justify-content: end;
    margin-right: 28px;
  }

  .del {
    background-color: #ffecec;
    color: #ff6b6b;
    font-weight: 700;
  }

  .modify {
    background-color: #3166ae;
  }

  .bar-title {
    font-size: 18px;
    line-height: 18px;
    color: #000000;
    border-left: 6px solid #3166ae;
    padding: 0 18px;
    margin-bottom: 16px;
    font-weight: bold;
  }

  .momey-total {
    display: flex;
    margin: 10px;
    line-height: 30px;

    .item {
      margin-right: 20px;
      width: 150px;
    }

    .item1 {
      width: 300px;
    }
  }

  .radio-bg {
    background: rgba(49, 102, 174, 0.1);
    padding: 0px 10px;
    border-radius: 4px;
  }
</style>